import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4816 17.4998H4.51799C3.8446 17.4998 3.2998 16.9512 3.2998 16.2731V8.2998H16.6998V16.2731C16.6998 16.9512 16.155 17.4998 15.4816 17.4998Z"
      fill={props?.fill || "#FFCDCB"}
    />
    <path
      d="M14.8898 6.2H10.0089C9.76146 6.2 9.54114 6.04926 9.44623 5.81972C9.35133 5.59018 9.40556 5.32296 9.57842 5.14824L12.0189 2.68157C12.1341 2.56509 12.29 2.5 12.4493 2.5C14.1305 2.5 15.4999 3.88407 15.4999 5.58333C15.4999 5.9225 15.2254 6.2 14.8898 6.2ZM11.4833 4.96667H14.178C13.9509 4.32259 13.3815 3.83954 12.69 3.74704L11.4833 4.96667Z"
      fill="white"
    />
    <path
      d="M9.99034 6.2H5.11004C4.77452 6.2 4.5 5.9225 4.5 5.58333C4.5 3.88407 5.8692 2.5 7.55019 2.5C7.71287 2.5 7.86876 2.56509 7.9806 2.68157L10.4208 5.14824C10.597 5.32639 10.6478 5.59018 10.5529 5.81972C10.458 6.04926 10.2377 6.2 9.99034 6.2ZM5.82514 4.96667H8.51947L7.31295 3.74704C6.62158 3.83954 6.05221 4.32259 5.82514 4.96667Z"
      fill="white"
    />
    <path
      d="M17.6923 8.5999H2.30769C2.13675 8.5999 2 8.46657 2 8.2999V6.4999C2 6.1699 2.27692 5.8999 2.61538 5.8999H17.3846C17.7231 5.8999 18 6.1699 18 6.4999V8.2999C18 8.46657 17.8632 8.5999 17.6923 8.5999Z"
      fill="#ffffff"
    />
    <path d="M8.7998 8.6001H11.1998V17.5001H8.7998V8.6001Z" fill="#ffffff" />
    <path d="M8.7998 5.8999H11.1998V8.5999H8.7998V5.8999Z" fill="white" />
  </svg>
);

export default SVGComponent;
